import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireInteractionService {
  public questionnaireId = new BehaviorSubject<object>(null);
  public questionnaireIdCast = this.questionnaireId.asObservable(); // Questionaiere Id subcription method

  public deleteAssessment = new BehaviorSubject<object>(null);
  public deleteAssessmentCast = this.deleteAssessment.asObservable();

  public openCategory = new BehaviorSubject<boolean>(null);
  public openCategoryCast = this.openCategory.asObservable();

  public valueChanges = new BehaviorSubject<boolean>(false);
  public valueChangesCast = this.valueChanges.asObservable();

  public leaveWithoutSave = new BehaviorSubject<boolean>(false);
  public leaveWithoutSaveCast = this.leaveWithoutSave.asObservable();

  public valueChangesInviteToComplete = new BehaviorSubject<boolean>(false);
  public valueChangesInviteToCompleteCast = this.valueChangesInviteToComplete.asObservable();

  public valueChangesOnDraw = new BehaviorSubject<boolean>(false);
  public valueChangesCastOnDraw = this.valueChangesOnDraw.asObservable();

  public addNew = new BehaviorSubject<string>(null);
  public addNewCast = this.addNew.asObservable();

  public clearAssesment = new BehaviorSubject<Object>(null);
  public clearAssesmentCast = this.clearAssesment.asObservable();

  public itemType = new BehaviorSubject<any>(null);
  public itemTypeCast = this.itemType.asObservable();

  public assesmentStatus = new BehaviorSubject<String>(null);
  public assesmentStatusCast = this.assesmentStatus.asObservable();

  public collaborationObject = new BehaviorSubject<String>(null);
  public collaborationObjectCast = this.collaborationObject.asObservable();

  public editAssesmentObject = new BehaviorSubject<any>(null);
  public editAssesmentCast = this.editAssesmentObject.asObservable();

  public editAssesmentID = new BehaviorSubject<any>(null);
  public editAssesmentIDCast = this.editAssesmentID.asObservable();

  public transferAssesment = new BehaviorSubject<object>(null);
  public transferAssesmentCast = this.transferAssesment.asObservable();


  public isAssessment = new BehaviorSubject<boolean>(false);
  public isAssessmentCast = this.isAssessment.asObservable();

  public isShowConfirm = new BehaviorSubject<object>(null);
  public isShowConfirmCast = this.isShowConfirm.asObservable();

  public resetQuestionaire = new BehaviorSubject<boolean>(false);
  public resetQuestionaireCast = this.resetQuestionaire.asObservable();

  public cancelAfterReview = new BehaviorSubject<boolean>(false);
  public cancelAfterReviewCast = this.cancelAfterReview.asObservable();

  public saveBeforeTimeOut = new BehaviorSubject<boolean>(false);
  public saveBeforeTimeOutCast = this.saveBeforeTimeOut.asObservable();

  public assessmentLastModified = new BehaviorSubject<object>(null);
  public assessmentLastModifiedCast = this.assessmentLastModified.asObservable();

  public resetConsent = new BehaviorSubject<boolean>(false);
  public resetConsentCast = this.resetConsent.asObservable();

  // Signals when the category component's assessmentDetails have been updated after a save.
  // The graph component waits for this before emitting the assessmentId event, preventing
  // the race condition where switchAssesment runs before assessmentDetails is refreshed.
  public assessmentDetailsSaved = new BehaviorSubject<boolean>(false);
  public assessmentDetailsSavedCast = this.assessmentDetailsSaved.asObservable();

  constructor() { }

  /**
   * Set a questionnaireID
   */
  setQusetionaireId(id) {
    this.questionnaireId.next(id);
  }

  /**
   * Distroy question category
   */
  distroyQuestionnaireID() {
    this.questionnaireId.complete();
  }

  deleteAssessmentID(id) {
    this.deleteAssessment.next(id);
  }

  setCategoryExpansion(value) {
    this.openCategory.next(value);
  }

  setValueChange(value) {
    this.valueChanges.next(value);
  }
  setValueLeaveWithoutSave(value) {
    this.leaveWithoutSave.next(value);
  }
  setEmailAssessmentValueChange(value) {
    this.valueChangesInviteToComplete.next(value);
  }

  setValueChangeOnDraw(value) {
    this.valueChangesOnDraw.next(value);
  }


  itemTypeCount(value) {
    this.itemType.next(value);
  }

  setAddnew(value) {
    this.addNew.next(value);
  }

  setClearAssesment(value) {
    this.clearAssesment.next(value);
  }

  setAssesmentStatus(value) {
    this.assesmentStatus.next(value);
  }

  setCollaborationObject(value) {
    this.collaborationObject.next(value);
  }

  setAssesmenteditObject(value) {
    this.editAssesmentObject.next(value);
  }

  setEmailAssesssmentId(value) {
    this.editAssesmentID.next(value);
  }

  setAssessmentTransferObject(value) {
    this.transferAssesment.next(value);
  }

  setAssessmentIfAny(value) {
    this.isAssessment.next(value);
  }

  setConfirmation(value) {
    this.isShowConfirm.next(value);
  }

  resetQuestionaireList(value) {
    this.resetQuestionaire.next(value);
  }

  cancelAfterReviewStatus(value) {
    this.cancelAfterReview.next(value);
  }

  saveAssessmentBeforeTimeOut(value) {
    this.saveBeforeTimeOut.next(value);
  }

  showAssessmentLastUpdatedTime(value) {
    this.assessmentLastModified.next(value);
  }
  resetConsentValue(value) {
    this.resetConsent.next(value);
  }

  setAssessmentDetailsSaved(value: boolean) {
    this.assessmentDetailsSaved.next(value);
  }
}
